import React, { FC } from 'react';
import { AngleDown, NoValuePlaceholder } from '@aleph/shared-components';
import { startCase } from 'lodash';
import { ICellRendererParams } from 'ag-grid-community';

type MultiValueCellRendererProps = {
	disabled?: boolean
	labelGetter?: (value: unknown) => string
} & ICellRendererParams;

const GroupOptimizationGoalCellRenderer: FC<MultiValueCellRendererProps> = (params) => {
	if (
		params.disabled
	) {
		return <NoValuePlaceholder />;
	}

	return (
		<div className="flex h-full items-center justify-between px-[8px] overflow-hidden">
			<div className="h-full">{startCase((params?.value ?? 'unset').toLowerCase())}</div>

			{
				params.column?.isCellEditable(params.node)
				&& <button
					onClick={() => params.api?.startEditingCell({
						colKey:   params.column ?? '',
						rowIndex: params.node?.rowIndex ?? 0,
					})}
				>
					<AngleDown
						height={16}
						width={16}
					/>
				</button>
			}
		</div>
	);
};

export default GroupOptimizationGoalCellRenderer;
